export const ALL_PHOTOS_CATEGORY_ID = 'all-photos'

export const GALLERY_CONTENT_MAX_WIDTH = 1920

export interface GalleryCategory {
  id: string
  label: string
  images: Array<App.Image>
  type?: 'room' | 'space'
}
